import {
  DISCOUNT_VALIDATE_REQUEST,
  DISCOUNT_VALIDATE_SUCCESS,
  DISCOUNT_VALIDATE_FAIL,
  DISCOUNT_VALIDATE_RESET,
} from "../Constants/DiscountConstants";

export const discountValidateReducer = (
  state = { loading: false, result: null, error: null },
  action
) => {
  switch (action.type) {
    case DISCOUNT_VALIDATE_REQUEST:
      return { loading: true, result: null, error: null };

    case DISCOUNT_VALIDATE_SUCCESS:
      return { loading: false, result: action.payload, error: null };

    case DISCOUNT_VALIDATE_FAIL:
      return { loading: false, result: null, error: action.payload };

    case DISCOUNT_VALIDATE_RESET:
      return { loading: false, result: null, error: null };

    default:
      return state;
  }
};